"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import LayoutMain from "@/components/layout/LayoutMain.vue";
import { AccountSessionMixins } from "@/service/account-session";
let Management = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.menuactive = "1";
  }
  created() {
    return __async(this, null, function* () {
      var _a, _b;
      if ((_a = this.$route.meta) == null ? void 0 : _a.hasOwnProperty("menuactive")) {
        this.menuactive = String((_b = this.$route.meta) == null ? void 0 : _b.menuactive);
      }
    });
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$session.type === "user" && !this.$session.permissions.any("ACCESS_CONTROL_SETTING", "ACCESS_CONTROL_APPROVAL")) {
        this.menuactive = "1";
      }
      if (this.$session.type === "user" && !this.$session.permissions.any("IN_PROCESS_MONITORING_SETTING", "IN_PROCESS_MONITORING_APPROVAL")) {
        this.menuactive = "2";
      }
    });
  }
};
Management = __decorateClass([
  Component({
    components: {
      LayoutMain
    }
  })
], Management);
export {
  Management as default
};
